export const Timing = {
	DROPDOWN_FOCUS_DELAY_MS: 100,
};
